import { render } from "./auth-shareholder.vue?vue&type=template&id=aca895c4&scoped=true"
import script from "./auth-shareholder.vue?vue&type=script&lang=js"
export * from "./auth-shareholder.vue?vue&type=script&lang=js"

import "./auth-shareholder.vue?vue&type=style&index=0&id=aca895c4&lang=scss"
import "./auth-shareholder.vue?vue&type=style&index=1&id=aca895c4&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca895c4"]])

export default __exports__